import { bindActionCreators } from 'redux';
import { withCookies } from 'react-cookie';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { selectLoading, selectError, selectAttribute } from 'shared/selectors';
import { checkIfAdmin, getRoleId, isLogin, checkIfAli } from 'store/selectors/loginState';
import { userVerification } from 'views/Registration/actions';
import { actLogout } from 'actions/loginStateActions';
import { actLogin, actLoginInit, unLocked, userSocialLogin } from './actions';
import LoginComponent from './view';

const mapStateToProps = (state, { cookies }) => {
  return {
    status: state.loginState.status,
    isUserLogin: isLogin(state) && !!cookies.get('token'),
    isAdmin: checkIfAdmin(state),
    isAli: checkIfAli(state),
    roleId: getRoleId(state),
    loginLocked: selectAttribute('loginReducer', 'login.error.locked', false)(state),
    loginLoading: selectLoading('loginReducer', 'login')(state),
    loginError: selectError('loginReducer', 'login')(state),
    hasToken: !!cookies.get('token'),
  };
};

const mapDispatchToProps = (dispatch, { cookies }) => ({
  onInit: bindActionCreators(actLoginInit, dispatch),
  onLogin: bindActionCreators(actLogin, dispatch),
  unLocked: bindActionCreators(unLocked, dispatch),
  onSocialLogin: bindActionCreators(userSocialLogin, dispatch),
  onActivateUser: bindActionCreators(userVerification, dispatch),
  onLogout: () => dispatch(actLogout(cookies)),
});

const Login = withCookies(withRouter(connect(mapStateToProps, mapDispatchToProps)(LoginComponent)));

export default Login;
